import { render } from "./SliderControl.vue?vue&type=template&id=64f17f72&ts=true"
import script from "./SliderControl.vue?vue&type=script&lang=ts"
export * from "./SliderControl.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__